const CALLBACK = 'asdfas2354radfads';
const mapElement = document.getElementById('project-mapmarkers-component-map');

(function() {
  if (mapElement != null) {
    const tag = document.createElement('script');
    tag.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDkv5U04yl9Zx7QJ0TqpDj2vrjPURxen74&callback=${CALLBACK}`;
    tag.defer = true;
    tag.async = true;

    document.head.appendChild(tag);
  }
})();

window[CALLBACK] = function initMap() {
  var map = new google.maps.Map(mapElement, {
    zoom: 3,
    center: { lat: 31, lng: 16 },
    mapTypeControl: false,
    streetViewControl: false,
    signInControl: false,
    scrollwheel: false,
    styles: [
      {
        featureType: 'administrative',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#444444',
          },
        ],
      },
      {
        featureType: 'landscape',
        elementType: 'all',
        stylers: [
          {
            color: '#f2f2f2',
          },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'all',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'road',
        elementType: 'all',
        stylers: [
          {
            saturation: -100,
          },
          {
            lightness: 45,
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'all',
        stylers: [
          {
            visibility: 'simplified',
          },
        ],
      },
      {
        featureType: 'road.arterial',
        elementType: 'labels.icon',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'transit',
        elementType: 'all',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'all',
        stylers: [
          {
            color: '#95ab18',
          },
          {
            visibility: 'on',
          },
        ],
      },
    ],
  });

  var infoWnd = new google.maps.InfoWindow();
  var markers = [];
  var iconBase = '/themes/sharedinterest/assets/images/';
  var icons = {
    lendingcustomer: {
      name: 'Producer Customer',
      icon: {
        url: iconBase + 'mapMarkerGreen.svg',
        scaledSize: new google.maps.Size(30, 30),
      },
    },
    charitybeneficiary: {
      name: 'Charity Partner',
      icon: {
        url: iconBase + 'mapMarkerBrown.svg',
        scaledSize: new google.maps.Size(30, 30),
      },
    },
    societybuyer: {
      name: 'Buyer Customer',
      icon: {
        url: iconBase + 'mapMarkerBlue.svg',
        scaledSize: new google.maps.Size(30, 30),
      },
    },
  };

  var features = setFeatures();

  // Create markers.
  var i = 0;
  features.forEach(function(feature) {
    var marker = new google.maps.Marker({
      position: feature.position,
      icon: icons[feature.type].icon,
      map: map,
      optimized: false,
    });

    google.maps.event.addListener(marker, 'mouseover', function() {
      var content =
        '<div class="project-mapmarkers-component-info-window" data-project="' +
        feature.project +
        '" data-type="' +
        feature.type +
        '"><p class="project-name"><a  href="#" class="text-dark">\
      ' +
        feature.name +
        '</a></p><a href="#"><img class="project-img" src="' +
        feature.img +
        '"></a><p class="project-location"><a href="#" class="text-dark">\
      <img class="project-icon" src="' +
        icons[feature.type].icon.url +
        '" alt="' +
        icons[feature.type].name +
        ' icon">' +
        feature.location +
        '\
      </a></p></div>';
      infoWnd.setContent(content);
      infoWnd.open(map, marker);
    });

    google.maps.event.addListener(marker, 'click', function() {
      openSideBar(feature.project, feature.type);
    });

    markers.push(marker);
  });

  var legend = document.getElementById('project-mapmarkers-component-legend');

  for (var key in icons) {
    var type = icons[key];
    var name = type.name;
    var icon = type.icon.url;
    var div = document.createElement('div');
    div.innerHTML = '<img src="' + icon + '"> ' + name;
    legend.appendChild(div);
  }

  map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(legend);
};

$(document).ready(function() {
  $('.side-close').click(function() {
    $(this)
      .parents('aside')
      .removeClass('open-side lendingcustomer charitybeneficiary societybuyer');
    $(this)
      .parents('aside')
      .find('.side-carousel .side-images')
      .slick('unslick');
    $(this)
      .parents('aside')
      .find('.side-carousel .side-images')
      .html('');
  });

  $('.project-mapmarkers-component-side .side-overlay').click(function() {
    if ($('.project-mapmarkers-component-side').hasClass('open-side')) {
      $('.side-close').trigger('click');
    }
  });

  $('#project-mapmarkers-component-map').on('click', '.project-mapmarkers-component-info-window a', function(event) {
    event.preventDefault();

    var type = $(this)
      .parents('.project-mapmarkers-component-info-window')
      .data('type');
    var id = $(this)
      .parents('.project-mapmarkers-component-info-window')
      .data('project');

    openSideBar(id, type);
  });
});

function openSideBar(id, type) {
  $('.project-mapmarkers-component-side')
    .removeClass('open-side lendingcustomer charitybeneficiary societybuyer')
    .addClass('open-side')
    .addClass(type);

  $.request('onShowSide', {
    data: { project_id: id },
    success: function(data) {
      if (Object.keys(data).length > 0) {
        var side = $('.project-mapmarkers-component-side');
        var path = '/images/';

        side.find('h2').text(data.location);
        side.find('.side-carousel .side-images.slick-initialized').slick('unslick');
        side.find('.side-carousel .side-images').html('');

        $.each(data.images, function(index, value) {
          side
            .find('.side-carousel .side-images')
            .append(
              '<div><img src="' +
                path +
                value.path.toString().match(/\/\/[^\/]+\/([^\.]+)/)[1] +
                '.' +
                value.extension +
                '?w=710&h=300"></div>'
            );
        });

        $('.side-carousel .side-images')
          .slick({
            dots: true,
            arrows: false,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
          })
          .delay(1000)
          .slick('setPosition');

        var url = side.find('.side-panel footer .read-more').data('url');

        side.find('.side-content h3').text(data.name);
        side.find('.side-content p').text(data.synopsis);
        side.find('.side-panel footer .read-more').prop('href', url + '/' + data.slug);
        side
          .find('.side-panel footer .facebook-share')
          .prop(
            'href',
            'http://www.facebook.com/share.php?u=https://shared-interest.com/' +
              url +
              '/' +
              data.slug +
              '&title=' +
              data.name
          );
        side
          .find('.side-panel footer .twitter-share')
          .prop(
            'href',
            'https://twitter.com/intent/tweet?url=https://shared-interest.com/' +
              url +
              '/' +
              data.slug +
              '&text=' +
              data.name
          );
      } else {
        $('.side-close').trigger('click');
      }
    },
  });
}



// WEBPACK FOOTER //
// ./themes/app/assets/js/map.js